import { css } from '@emotion/core';
import theme from "../../themes/default";
const medium =
/*#__PURE__*/
process.env.NODE_ENV === "production" ? {
  name: "7ov5s-medium",
  styles: "height:40px;label:medium;"
} : {
  name: "7ov5s-medium",
  styles: "height:40px;label:medium;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9CdXR0b24vQnV0dG9uLnN0eWxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdrQiIsImZpbGUiOiIuLi8uLi8uLi8uLi90bXAvd2ViL2NvbXBvbmVudHMvQnV0dG9uL0J1dHRvbi5zdHlsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHRoZW1lIGZyb20gJyRhdWxhL3RoZW1lJztcblxuY29uc3QgbWVkaXVtID0gY3NzYFxuICBoZWlnaHQ6IDQwcHg7XG5gO1xuXG5jb25zdCBzbWFsbCA9IGNzc2BcbiAgaGVpZ2h0OiAzMnB4O1xuICBsaW5lLWhlaWdodDogJHt0aGVtZS5mb250LmxpbmVIZWlnaHQuc21hbGx9O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQge1xuICBjb250YWluZXI6IHtcbiAgICBieVNpemU6IHtcbiAgICAgIHNtYWxsLFxuICAgICAgbWVkaXVtLFxuICAgIH0sXG4gIH0sXG59O1xuIl19 */"
};
const small =
/*#__PURE__*/

/*#__PURE__*/
css("height:32px;line-height:", theme.font.lineHeight.small, ";label:small;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9CdXR0b24vQnV0dG9uLnN0eWxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9pQiIsImZpbGUiOiIuLi8uLi8uLi8uLi90bXAvd2ViL2NvbXBvbmVudHMvQnV0dG9uL0J1dHRvbi5zdHlsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHRoZW1lIGZyb20gJyRhdWxhL3RoZW1lJztcblxuY29uc3QgbWVkaXVtID0gY3NzYFxuICBoZWlnaHQ6IDQwcHg7XG5gO1xuXG5jb25zdCBzbWFsbCA9IGNzc2BcbiAgaGVpZ2h0OiAzMnB4O1xuICBsaW5lLWhlaWdodDogJHt0aGVtZS5mb250LmxpbmVIZWlnaHQuc21hbGx9O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQge1xuICBjb250YWluZXI6IHtcbiAgICBieVNpemU6IHtcbiAgICAgIHNtYWxsLFxuICAgICAgbWVkaXVtLFxuICAgIH0sXG4gIH0sXG59O1xuIl19 */"), "label:small;");
export default {
  container: {
    bySize: {
      small,
      medium
    }
  }
};